import React, { Component, useEffect } from "react";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import * as am4plugins_forceDirected from "@amcharts/amcharts4/plugins/forceDirected";
import PropTypes from 'prop-types';

am4core.useTheme(am4themes_animated);

const PackedChart = ({ dataset, id, showLabel, size, fontSize, reqHeight }) => {
	let height = '200px'
	if (reqHeight != null) {
		height = reqHeight + 'px'
	}
	// static propTypes = {
	// 	id: PropTypes.string.isRequired,
	// 	dataset: PropTypes.array.isRequired,
	// 	showLabel: PropTypes.bool.isRequired,
	// 	size: PropTypes.number.isRequired,
	// 	fontSize: PropTypes.number.isRequired,
	// };
	// componentDidUpdate(prevProps) {
	// 	if (prevProps.dataset !== this.props.dataset) {
	// 		this.renderChart(this.props.dataset);
	// 	}
	// }
	useEffect(() => {
		// const { id, dataset, showLabel, size, fontSize } = this.props;
		var chart = am4core.create(
			id,
			am4plugins_forceDirected.ForceDirectedTree
		);
		var series = chart.series.push(
			new am4plugins_forceDirected.ForceDirectedSeries()
		);
		series.data = dataset

		series.dataFields.name = "key";
		series.dataFields.id = "key";
		series.dataFields.value = "value";

		series.colors.list = [
			am4core.color("#FEBC04"),
			am4core.color("#FF3838"),
			am4core.color("#03C46B"),
			am4core.color("#4185F3"),
			am4core.color("#F44174"),
		];

		series.links.template.distance = 20; // Set default distance between nodes
		series.links.template.strength = 0.7; // Adjust the strength of the links
		series.nodes.template.tooltipText = "{key}";
		series.nodes.template.fillOpacity = 1;
		series.nodes.template.outerCircle.strokeOpacity = 0;
		series.nodes.template.outerCircle.fillOpacity = 0;
		series.nodes.template.outerCircle.propertyFields.stroke = "color";
		series.nodes.template.circle.propertyFields.stroke = "color";
		series.nodes.template.circle.propertyFields.fill = "color";

		if (showLabel) {
			series.nodes.template.label.text = "{key}";
		}

		series.fontSize = fontSize;
		series.minRadius = 15;
		series.maxRadius = size;
		series.manyBodyStrength = -5;
	}, [dataset, id])

	// componentWillUnmount() {
	// 	if (this.chart) {
	// 		this.chart.dispose();
	// 	}
	// }

	// render() {
	// 	const { id } = this.props;
		return <div id={id} style={{ width: "100%", height: height }}></div>;
	// }
}

export default PackedChart;
